import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import AvatarImage from './AvatarImage'

import './Avatar.scss'

export const Avatar = ({ name, image, color, size, type, clickable }) => {
  const classList = useMemo(() => {
    const list = ['x-avatar']

    if (color) {
      list.push('is-color-' + color)
    }

    if (size) {
      list.push('is-size-' + size)
    }

    if (type) {
      list.push('is-type-' + type)
    }

    if (clickable) {
      list.push('is-clickable')
    }

    return list.join(' ')
  }, [clickable, color, size, type])

  return (
    <div className={classList}>
      <div className="--name">{name}</div>
      <AvatarImage name={name} image={image} />
    </div>
  )
}

Avatar.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary', 'dark']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  type: PropTypes.oneOf(['primary', 'secondary']),
  clickable: PropTypes.bool,
}

Avatar.defaultProps = {
  name: '',
  image: '',
  color: 'primary',
  size: 'medium',
  type: 'primary',
  clickable: false,
}

export default Avatar
